export const isProduction = env.REACT_APP_ACCOUNT_NAME === "propertybid-production";

export const isStaging = env.REACT_APP_ACCOUNT_NAME === "propertybid-staging";

export const isLocal = env.REACT_APP_ACCOUNT_NAME === "propertybid-local";
